import React from 'react'

const BodyWaxingInUptown = () => {
  return (
    <div>
      
    </div>
  )
}

export default BodyWaxingInUptown
